/* Fiche produit — onglets « Description » et « Guide de pose » (16/09/2026).
   Le contenu est déjà ouvert au chargement : cliquer sur l'onglet actif ne changeait rien
   à l'écran, et des clients cliquaient plusieurs fois en pensant que c'était bloqué.
   On amène le contenu à l'écran et on le surligne une seconde. */
(function () {
  function init() {
    var nav = document.querySelector('.hg-prod-tabs__nav');
    var content = document.querySelector('.hg-prod-tabs__content');
    if (!nav || !content) return;

    var style = document.createElement('style');
    style.textContent = '.hg-prod-tab--flash{animation:hgTabFlash .9s ease}' +
      '@keyframes hgTabFlash{0%{background:rgba(145,228,4,.28)}100%{background:transparent}}' +
      '@media (prefers-reduced-motion:reduce){.hg-prod-tab--flash{animation:none}}';
    document.head.appendChild(style);

    nav.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest ? e.target.closest('.hg-prod-tabs__btn') : null;
      if (!btn) return;
      setTimeout(function () {
        var panel = document.getElementById('tab-' + btn.getAttribute('data-tab')) || content;
        var r = panel.getBoundingClientRect();
        if (r.top < 0 || r.bottom > window.innerHeight) {
          panel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        panel.classList.add('hg-prod-tab--flash');
        setTimeout(function () { panel.classList.remove('hg-prod-tab--flash'); }, 950);
      }, 60);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
